import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
// Common
import { barcodeStages } from "./Constants";
import { CommonBodyForTable, commonCloseDialogFooter, srBodyTemplate } from "../Common/CommonComponents";
// Services
import ApiServices from "../../service/api/ApiServices";
const apiServices = new ApiServices();

const saved = localStorage.getItem("user");
const initialValue = JSON.parse(saved);

// ========================================= Facilitywise Barcode Details=========================================================
// =================================================== Nikhil Devne =============================================

export const FacilityWiseBarcodeDetails = (props) => {

    const [barcodeData, setBarcodeData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [globalFilter1, setGlobalFilter1] = useState(null);
    const [materialDialog, setMaterialDialog] = useState(false);
    const [selectedBarcodeStage, setSelectedBarcodeStage] = useState({ name: 'Delivered', code: 'delivered' })
    const [accMaterialData, setAccMaterialData] = useState(null);
    const [materialLoading, setMaterialLoading] = useState(false);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [stage, setStage] = useState('delivered');

    const dt = useRef(null);
    const dt1 = useRef(null);

    useEffect(() => {
        getData(stage)
    }, [])

    /**
     * This function is used to get barcode details stage wise
     * @param {*} stage 
     */
    const getData = async (stage) => {
        setLoading(true)
        const response = await apiServices.facilityBarcodeDetails({ stage: stage }); // API gets facility barcode details
        if (response.status === 200) {
            setBarcodeData(response?.data?.data.filter((item) => item.userid));
            setLoading(false)
        } else {
            setBarcodeData([])
            setLoading(false)
        }
        setLoading(false)
    }

    /**
     * function generate excel file for facility wise barcode count
     */
    const exportCSV = () => { dt.current.exportCSV() }

    /**
     * function generate excel file for barcode details for selected facility
     */
    const materialExportCSV = () => { dt1.current.exportCSV() }

    /**
     * function sets stage of barcode we want to find on event
     * @param {*} e 
     */
    const changeBarcodeStage = (e) => {
        setStage(e.value.code)
        getData(e.value.code)
        setSelectedBarcodeStage(e.value)
    }

    /**
     * opens dialog fo deatail barcode list for selected facility
     * @param {*} data 
     */
    const openMaterialDialog = async (data) => {
        let barcodes = data?.barcodes.map((barcode) => {
            return {
                barcode: barcode,
                stage: selectedBarcodeStage.name
            }
        });
        console.log(data)
        setSelectedFacility(data)
        setMaterialLoading(true)
        setAccMaterialData(barcodes.length ? barcodes : [])
        setMaterialDialog(true)
        setMaterialLoading(false)
    }

    /**
     * hides detailed barcode list dialog box
     */
    const hideMaterialDialog = () => {
        setMaterialDialog(false)
        setGlobalFilter1(null)
    }

    // this is header for main grid
    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                {
                    initialValue?.userType == 'owner' &&
                    <div className="p-inputgroup p-m-1" >
                        <Button className="custom-group-btn" label="Barcode Stage" />
                        <Dropdown value={selectedBarcodeStage} onChange={changeBarcodeStage} options={barcodeStages} optionLabel="name" placeholder="Select Barcode Stage" filter className="p-mr-2 multiselect-custom" />
                    </div>
                }

            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup p-m-1">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button icon="pi pi-download" className='custom-group-btn p-button-rounded p-mt-2 p-mx-4' onClick={exportCSV} />
                </div>
            </span>

        </div>
    );

    // this header is for detailed barcode list dialog box
    const header1 = (
        <div className="table-header">
            <span className="p-input-icon-right"></span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter1(e.target.value)} placeholder="Search..." />
                    <Button icon="pi pi-download" className='custom-group-btn p-button-rounded p-mt-2 p-mx-4' onClick={materialExportCSV} />
                </div>
            </span>
        </div>
    );

    /**
     * this is action template for main grid
     * @param {*} rowData 
     * @returns 
     */
    const actionBodyTemplate = rowData => (
        <>
            <span className="p-column-title">Action</span>
            <div className="actions" style={{ display: "flex" }}>
                <Button icon="pi pi-eye" title="View Invoices" className="p-button-rounded p-button-success p-mr-2 p-mb-2" onClick={() => { openMaterialDialog(rowData) }} />
            </div>
        </>
    )

    // hides detailed barcode list dialogue
    const materialDialogFooter = commonCloseDialogFooter('Cancel', hideMaterialDialog)

    return (
        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <DataTable className="datatable-responsive" ref={dt} value={barcodeData} paginator rows={10} rowsPerPageOptions={[5, 10, 25]} loading={loading} globalFilter={globalFilter} header={header} emptyMessage="No Data found." footer={`In total there are ${barcodeData?.length ? barcodeData?.length : 0} accounts.`}
                            exportFilename={`${selectedBarcodeStage.name} Barcode Count(Facility)`} >
                            <Column field="id" header="Sr.No." body={srBodyTemplate} exportable={false}></Column>
                            <Column field="facname" header="Facility Name" body={CommonBodyForTable} sortable></Column>
                            <Column field="facid" header="Facility ID" body={CommonBodyForTable} sortable></Column>
                            <Column field="userid" header="User ID" body={CommonBodyForTable} sortable></Column>
                            <Column field="barcodeCount" header="Barcode Count" style={{ textAlign: 'center' }} body={CommonBodyForTable} sortable></Column>
                            <Column header="Actions" body={actionBodyTemplate} ></Column>
                        </DataTable>
                    </div>
                </div>
            </div>

            <Dialog visible={materialDialog} style={{ width: "600px" }} header={`Barcode Details`} modal className="p-fluid" footer={materialDialogFooter} onHide={hideMaterialDialog} maximizable={true} blockScroll={true}>
                <div className="card">
                    <div className="p-grid table-demo p-m-2">
                        <DataTable ref={dt1} value={accMaterialData} paginator className="p-datatable-customers" rows={10} dataKey="id" rowHover emptyMessage="No Data found." header={header1}
                            exportFilename={`${selectedFacility?.facname} ${selectedBarcodeStage.name} Barcode Details`} globalFilter={globalFilter1} loading={materialLoading}>
                            <Column field="id" header="Sr.No." body={srBodyTemplate} exportable={false} style={{ width: '6rem' }}></Column>
                            <Column field="barcode" header="Barcode" sortable body={CommonBodyForTable} style={{ width: '10rem' }} ></Column>
                            <Column field="stage" header="Stage" sortable body={CommonBodyForTable} style={{ width: '10rem' }} ></Column>
                        </DataTable>
                    </div>
                </div>
            </Dialog>

        </>
    )
}